import { createContext } from "react";
import type { MessagingSocket } from "@/lib/messaging-socket";

export interface MessagingContextValue {
  socket: MessagingSocket | null;
  subscribe: (conversationId: string) => Promise<void>;
  emitTyping: (conversationId: string, isTyping: boolean) => void;
}

export const MessagingContext = createContext<MessagingContextValue | null>(
  null,
);
